export default {
  
    tipoFianza: {
    }
}